<template>
    <v-overlay :z-index="zIndex" :value="loginmodal" absolute>
        <v-card
            min-width="600"
            min-height="400"
            class="px-10 py-2 d-flex flex-column align-center justify-space-around"
            color="myGreen"
        >
            <v-card width="400" elevation="0" class="transparent">
                <h2 class="text-center">Login</h2>
            </v-card>
            <v-card-text width="400" elevation="0" class="transparent">
                <v-text-field
                    class="black--text mb-4"
                    ref="email"
                    v-model="email"
                    label="Email"
                    :error-messages="emailTextError()"
                ></v-text-field>
                <v-text-field
                    class="text--black"
                    ref="password"
                    v-model="password"
                    label="Password"
                    type="password"
                    :error-messages="passwordTextError()"
                ></v-text-field>
            </v-card-text>
            <v-card-actions elevation="0" class="text-center transparent">
                <v-btn width="300" class="myBlue" @click="submit">Login</v-btn>
            </v-card-actions>
        </v-card>
    </v-overlay>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { axios } from "../../api";

export default {
    data: () => ({
        zIndex: 100,
        email: "",
        password: "",
        emailTextErrorMsg: "",
        passwordTextErrorMsg: "",
        emailFromAxios: null,
        passwordFromAxios: null,
    }),
    computed: {
        ...mapGetters(["loginmodal"]),
    },
    methods: {
        ...mapActions(["SET_LOGIN_MODAL"]),
        emailTextError() {
            return this.emailTextErrorMsg;
        },
        passwordTextError() {
            return this.passwordTextErrorMsg;
        },
        submit() {
            if (this.email == this.emailFromAxios && this.password == this.passwordFromAxios) {
                this.email = "";
                this.password = "";
                this.emailTextErrorMsg = "";
                this.passwordTextErrorMsg = "";
                this.SET_LOGIN_MODAL(false);
            } else {
                this.SET_LOGIN_MODAL(true);
                this.emailTextErrorMsg = "Wrong email";
                this.passwordTextErrorMsg = "Password Is Required";
            }
        },
    },
    mounted() {
        axios
            .get("/passwordKitchen")
            .then((res) => {
                console.log(res)
                this.emailFromAxios = res.data[0].email;
                this.passwordFromAxios = res.data[0].password;
            })
            .catch((err) => {
                console.log(err);
            });
    },
};
</script>
